import React, { useState } from "react";
import ReactDom from "react-dom";
import { mainFeatures } from "../../constants";
import { useNavigate } from "react-router-dom";
import { settings, stars, support } from "../../assets";
import OverlayUpgrade from "../OverlayUpgrade";

const ModalClickOpenNavbar = ({
  openNavbar,
  package_,
  setLoc,
  setShowPopup,
  interceptFunc = false,
}) => {
  const navigate = useNavigate();
  const [openOverlay, setOpenOverlay] = useState(false);
  const isFree = package_.toLowerCase().includes("free");
  return ReactDom.createPortal(
    <div
      id="dropdownNavbarMenu"
      className={`${
        openNavbar ? "" : "hidden"
      } fixed shadow-lg bg-white py-2 z-[99999] w-[90vw] rounded-lg h-fit top-20 left-5 border flex flex-col`}
    >
      {openOverlay && <OverlayUpgrade setOpenOverlay={setOpenOverlay} />}
      <div className="flex flex-col gap-1 w-full">
        {mainFeatures.map((val, ind) => (
          <div
            className={`flex flex-row relative w-full text-[14px] items-center py-2 px-3 rounded-lg cursor-pointer hover:font-bold group hover:bg-gray-100`}
            onClick={() => {
              if ((ind == 3 || ind == 4) && isFree) {
                setOpenOverlay(true);
              } else {
                if (interceptFunc) {
                  setLoc(val.path);
                  setShowPopup(true);
                } else {
                  navigate(val.path);
                }
              }
            }}
            key={ind}
          >
            <div className="flex flex-col relative">
              <img src={val.icon} className="w-[30px]" />
              {(ind == 3 || ind == 4) &&
              package_.toLowerCase().includes("free") ? (
                <img
                  src={stars}
                  alt=""
                  className="absolute w-3 h-3 top-0 right-0"
                />
              ) : null}
            </div>

            <div className={`font-sans text-black ml-3`}>{val.id}</div>
          </div>
        ))}
        <div className="flex flex-col w-full gap-3 text-[14px]">
          <hr className="bg-black w-full" />
          <div
            className={`flex flex-row w-full items-center py-2 px-3 rounded-lg cursor-pointer hover:font-bold hover:bg-gray-100"
            `}
            onClick={() => {
              if (interceptFunc) {
                setLoc("/settings");
                setShowPopup(true);
              } else {
                navigate("/settings");
              }
            }}
          >
            <img src={settings} className="w-[30px]" />
            <div
              className={`overflow-hidden transition-all font-sans text-black ml-3`}
            >
              Setting
            </div>
          </div>
          <div
            className={`flex flex-row w-full items-center py-2 px-3 rounded-lg cursor-pointer hover:font-bold hover:bg-gray-100"
            `}
            onClick={() => {
              if (interceptFunc) {
                setLoc("/support");
                setShowPopup(true);
              } else {
                navigate("/support");
              }
            }}
          >
            <img src={support} className="w-[30px]" />
            <div
              className={`overflow-hidden transition-all font-sans text-black ml-3`}
            >
              Support
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default ModalClickOpenNavbar;
